import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {NotificationsSubscriptionsMenu} from './NotificationsSubscriptionsMenu'

registerReactPartial('notifications-subscriptions-menu', {
  Component: NotificationsSubscriptionsMenu,
})
